
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { BlogPost } from "../types";
import { colorSchemes } from "../constants";
import { format } from "date-fns";

interface BlogPostPreviewProps {
  post: BlogPost;
  colors: typeof colorSchemes.default;
  onBack: () => void;
}

export const BlogPostPreview = ({ post, colors, onBack }: BlogPostPreviewProps) => {
  return (
    <article className="max-w-4xl mx-auto px-8 py-16">
      <Button
        variant="ghost"
        onClick={onBack}
        className="mb-8"
        style={{ color: colors.primary }}
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back to Posts
      </Button>

      {post.featuredImage && (
        <img
          src={post.featuredImage}
          alt={post.title}
          className="w-full h-[400px] object-cover rounded-lg mb-8"
        />
      )}

      <div className="space-y-4">
        <h1 
          className="text-4xl font-bold"
          style={{ color: colors.primary }}
        >
          {post.title}
        </h1>

        <div className="flex gap-4 items-center text-sm text-muted-foreground">
          <time>{format(new Date(post.publishedAt), 'MMMM d, yyyy')}</time>
          <div className="flex gap-2">
            {post.tags.map(tag => (
              <span
                key={tag}
                className="px-2 py-1 rounded-full text-xs"
                style={{ 
                  background: `${colors.primary}20`,
                  color: colors.primary
                }}
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        <div
          className="prose prose-lg max-w-none mt-8"
          style={{ color: colors.dark }}
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
      </div>
    </article>
  );
};
